import { CancelledError } from "@core-ts/StandardError"
import { ProfileCounters } from "./ProfileCounters"
import { SessionInstanceCache } from "@core-ts/Cache/SessionInstanceCache"

export class Request {
    constructor(
        requestId: string|null,
        readonly type: string, //"frontend"|"gateway"|"mqtt",
        private _internalSerial?: string
    ) { 
        this.requestId = requestId ?? this.generateRequestId()
        this.cache = new SessionInstanceCache<unknown|undefined>("Request." + this.requestId, 5, 200)
    }
    
    readonly requestId: string
    readonly cache
    readonly profileCounters = new ProfileCounters()
    readonly sqlTrace: { queryString: string, executionTimeMs: number }[] = []
    private _isCancelled = false

    cancel(): void {
        this._isCancelled = true
    }
    get isCancelled(): boolean {
        return this._isCancelled
    }
    throwIfCancelled(): void {
        if(this._isCancelled) {
            throw new CancelledError()
        }
    }

    // We allow the internal serial to be set after the request has been created since the internal serial is not known in some cases
    // Note that the internal serial is only to be used for debugging purposes and that it cannot be really be trusted
    set internalSerial(serial: string|undefined) {
        if(serial === undefined) {
            throw new Error("Internal serial cannot be set to undefined")
        }
        if(this._internalSerial !== undefined) {
            throw new Error("Internal serial already set")
        }
        this._internalSerial = serial
    }
    get internalSerial(): string|undefined {
        return this._internalSerial
    }

    private generateRequestId(): string {
        let result = 'RQ';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < 16; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength))
        }
        return result
    }

    getProfileReportString(): string {
        let result = ""
        
        const sqlQueryCount = this.profileCounters.sqlQueryCount.get()
        const sqlQueryTime = this.profileCounters.sqlQueryTime.get()
        const sqlQueryResultRows = this.profileCounters.sqlQueryResultRows.get()
        if(sqlQueryCount > 0 || sqlQueryTime > 0 || sqlQueryResultRows > 0 ) {
            result += "SQL Query Count: " + this.profileCounters.sqlQueryCount.get() + ", "
            result += "SQL Query Time: " + this.profileCounters.sqlQueryTime.get() + " ms, "
            result += "SQL Query Result Rows: " + this.profileCounters.sqlQueryResultRows.get() + ", " 
        }

        if( this.sqlTrace.length > 0 ) {
            result += "SQL Trace: ["
            for(const sqlTraceEntry of this.sqlTrace) {
                result += `{ "${sqlTraceEntry.queryString}" took ${sqlTraceEntry.executionTimeMs} ms }, `
            }
            result += "] "
        }

        return result
    }
}

